import React, { Fragment, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { Controller, useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
import EventSelctionService from "../services/eventSelectionService";
import Header from "../components/Header";
import Loaing from "../icons/loaing";

import "react-datepicker/dist/react-datepicker.css";
import CalendarIcon from "../icons/calendar";
import { Dialog, Transition } from "@headlessui/react";
import postEvent from "../services/eventService";

export type eventsType = {
  perimeter: string;
  institutionId: string;
  period: string;
  event: string;
};

const schema = yup.object({
  perimeter: yup.string().required(),
  period: yup.string().required(),
  // array().of(yup.string()).min(2, "end date are required").required(),
  event: yup.string().required(),
  institutionId: yup.string().required(),
});

const EventSelection: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [date, setDate] = useState<null | Date>(null);
  const [loading, setLoading] = useState(false);
  const [perimeter, setPerimeter] = useState("");
  const convertDate = (value: any) => {
    const result = value.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return result;
  };

  let [isOpen, setIsOpen] = useState(false);
  const supportedLngs = [
    { country: "Argentina", lang: "es" },
    { country: "Belgium", lang: "nl" },
    { country: "Colombia", lang: "es" },
    { country: "Colombia", lang: "es" },
    { country: "France", lang: "fr" },
    { country: "Germany", lang: "de" },
    { country: "India", lang: "en" },
    { country: "Luxembourg", lang: "en" },
    { country: "Netherlands", lang: "nl" },
    { country: "Reunion", lang: "fr" },
    { country: "Singapore", lang: "en" },
    { country: "Swizerland", lang: "en" },
    { country: "UAE", lang: "en" },
    { country: "USA", lang: "en" },
  ];
  const findLangByCountry = (country: string) => {
    const result = supportedLngs.filter((lang) => {
      return lang.country === country;
    });
    if (result.length > 0) {
      return result[0].lang;
    } else {
      return "uk";
    }
  };
  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const [event, setEvent] = useState("");

  // const [startDate, endDate] = dateRange;
  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<eventsType>({ resolver: yupResolver(schema) });

  const onSubmit: SubmitHandler<eventsType> = async (data) => {
    setLoading(true);
    const lang = findLangByCountry(data.perimeter);
    i18n.changeLanguage(lang);

    try {
      EventSelctionService({
        ...data,
        period: convertDate(date),
      });
      navigate(
        data.event.toString() === "Incidents"
          ? `/forms/Incidents?lng=${lang}`
          : data.event === "Health event"
          ? `/forms/health-events?lng=${lang}`
          : data.event === "Other safety events"
          ? `/forms/safety-events?lng=${lang}`
          : data.event === "Epidemic"
          ? `/forms/epidemic?lng=${lang}`
          : data.event === "Food Safety Issue"
          ? `/forms/food-safety?lng=${lang}`
          : data.event?.toString() === "Nothing to declare"
          ? `/forms/nothing-to-declare?lng=${lang}`
          : ""
      );

      toast.success("event details has been set");
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  return (
    <>
      <section className="relative">
        <Header />
        <div className="grid items-center lg:px-60 md:px-32 sm:px-10 px-5 min-h-screen font-Poppins bg-[#1E408E] py-28">
          <form onSubmit={handleSubmit(onSubmit)} className="grid gap-5">
            <h1 className="text-[2.4rem] text-center font-bold text-white mb-16">
              <Trans t={t}>Start Reporting Here</Trans>
            </h1>

            <section className="grid lg:gap-16 gap-5 md:grid-cols-2 grid-cols-1">
              <div className="flex flex-col">
                <label
                  htmlFor="perimeter"
                  className="text-base font-medium font-Inter text-white mb-2"
                >
                  <Trans i18nKey="Select Perimeter">Select Perimeter</Trans> *
                </label>
                <select
                  {...register("perimeter")}
                  name="perimeter"
                  id="perimeter"
                  className={`bg-[#1E408E] border border-white rounded p-3 focus-within:outline-none ${
                    perimeter === "" ? "text-gray-400" : "text-white"
                  }`}
                  value={perimeter}
                  onChange={(e) => setPerimeter(e.target.value)}
                >
                  <option value="" className="hidden" disabled hidden>
                    Select
                  </option>
                  <option value="Argentina">Argentina</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Colombia">Colombia</option>
                  <option value="France">France</option>
                  <option value="Germany">Germany</option>
                  <option value="India">India</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="Reunion">Reunion</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="UAE">UAE</option>
                  <option value="USA">USA</option>
                </select>
                {errors["perimeter"] && (
                  <p className="text-red-500 mt-2 text-sm">
                    {errors["perimeter"]?.message}
                  </p>
                )}
              </div>

              <div className="flex flex-col">
                <label
                  htmlFor="institutionId"
                  className="text-base font-medium font-Inter text-white mb-2"
                >
                  <Trans i18nKey="Enter your ID institution">
                    Enter your ID institution
                  </Trans>{" "}
                  *
                </label>
                <input
                  {...register("institutionId")}
                  type="text"
                  className="bg-[#1E408E] border text-white border-white rounded p-3 focus-within:outline-none placeholder:text-gray-400"
                  placeholder="Free text"
                />
                {errors["institutionId"] && (
                  <p className="mt-2 text-red-500 text-sm">
                    {errors["institutionId"]?.message}
                  </p>
                )}
              </div>
            </section>

            <section className="grid lg:gap-16 gap-5 md:grid-cols-2 grid-cols-1">
              <div className="flex flex-col">
                <label
                  htmlFor="period"
                  className="text-base font-medium font-Inter text-white mb-2"
                >
                  <Trans i18nKey="Select today's date, the completion date of the form">
                    Select today's date, the completion date of the form
                  </Trans>{" "}
                  *
                </label>

                <div className="relative flex items-center pr-3 bg-[#1E408E] border text-white border-white rounded">
                  <Controller
                    control={control}
                    name="period"
                    render={({ field }) => (
                      <DatePicker
                        filterDate={(d) => {
                          return new Date() > d;
                        }}
                        selectsRange={false}
                        startDate={date}
                        endDate={date}
                        onChange={(update) => {
                          field.onChange(update?.toDateString());
                          setDate(update);
                        }}
                        placeholderText="Date"
                        selected={date}
                        dateFormat={"DD MMM yyyy"}
                        value={date?.toDateString()}
                        isClearable={true}
                        className="w-full relative z-10 bg-transparent focus:border-none p-3 focus:ring-0 focus-within:outline-none border-none placeholder:text-gray-400"
                      />
                    )}
                  />

                  <CalendarIcon />
                </div>
                {errors["period"] && (
                  <p className="text-red-500 mt-2 text-sm">
                    {errors["period"]?.message}
                  </p>
                )}
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="event"
                  className="text-base font-medium font-Inter text-white mb-2"
                >
                  <Trans i18nKey="Select the event">Select the event</Trans> *
                </label>
                <select
                  {...register("event")}
                  id="event"
                  className={`bg-[#1E408E] border border-white rounded p-3 focus-within:outline-none ${
                    event === "" ? "text-gray-400" : "text-white"
                  }`}
                  placeholder="Select Perimeter"
                  value={event}
                  onChange={(e) => setEvent(e.target.value)}
                >
                  <option value="" className="hidden" disabled hidden>
                    Select
                  </option>
                  <option value="Incidents">Incidents</option>
                  <option value="Health event">Health event</option>
                  <option value="Other safety events">
                    Other safety events
                  </option>
                  <option value="Epidemic">Epidemic</option>
                  <option value="Food Safety Issue">Food Safety Issue</option>
                  <option value="Nothing to declare">Nothing to declare</option>
                </select>
                {errors["event"] && (
                  <p className="text-red-500 text-sm mt-2">
                    {errors["event"]?.message}
                  </p>
                )}
              </div>
            </section>
            <div className="flex justify-center mt-10">
              <label
                htmlFor="submit"
                className="px-7 py-3 bg-white text-sm font-bold text-[#1E408E] rounded-3xl cursor-pointer"
              >
                <Trans i18nKey="Start">{"Start >"}</Trans>
              </label>
              <input type="submit" id="submit" className="hidden" />
            </div>
            {loading && (
              <div className="fixed inset-0 z-50 w-screen h-screen flex items-center justify-center bg-black/70">
                <Loaing className="text-white" />
              </div>
            )}
          </form>
          <button
            className="absolute transform -translate-x-1/2 left-1/2 lg:transform-none bottom-14 lg:left-14 cursor-pointer"
            onClick={openModal}
          >
            <img src="/images/question.png" alt="" />
          </button>
        </div>
      </section>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <Trans i18nKey="Need help">Need help?</Trans>
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      <Trans i18nKey="do_u_have_problem">
                        Do you have a problem? Please contact
                      </Trans>{" "}
                      <Trans i18nKey="to_as_your_question">
                        to ask your question.
                      </Trans>
                    </p>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      <Trans i18nKey="got_it">Got it!</Trans>
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default EventSelection;
